export enum AnalysisSummarySectionId {
  SupplierInformation = "SupplierInformation",
  AdviserInformation = "AdviserInformation",
  Objective = "Objective",
  WhatsIncluded = "WhatsIncluded",
  ProductRecommendations = "ProductRecommendations",
  PlatformSelected = "PlatformSelected",
  FeatureAnalysis = "FeatureAnalysis",
  BusinessMetricsAnalysis = "BusinessMetricsAnalysis",
  PortfolioDetails = "PortfolioDetails",
  PortfolioComposition = "PortfolioComposition",
  FeeEstimates = "FeeEstimates",
  SmaPortfolioFees = "SmaPortfolioFees",
  ConcludingRemarks = "ConcludingRemarks",
  PlatformComments = "PlatformComments",
  PlatformSpecificComments = "PlatformSpecificComments",
  PlatformIncluded = "PlatformIncluded",
  FeatureIncluded = "FeatureIncluded",
  Appendix = "Appendix",
  AppendixPlatformComments = "AppendixPlatformComments",
  AppendixFeatureAnalysis = "AppendixFeatureAnalysis",
  AppendixBusinessMetricAnalysis = "AppendixBusinessMetricAnalysis",
  AppendixPortfolioComposition = "AppendixPortfolioComposition",
  AppendixFeeEstimateAnalysis = "AppendixFeeEstimateAnalysis",
  AppendixSmaPortfolioFees = "AppendixSmaPortfolioFees",
  Disclaimers = "Disclaimers",
}
